export default __webpack_public_path__ + "media/assets/images/right-bg-image-bd305d6cfb65213175f9e460ff7c694b.png";